export default property => property.match(/^(Webkit|Moz|O|ms)/) !== null
